import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  fieldset: {
    composes: 'fieldset fieldset--no-label',
  },
  withPrefix: {
    composes: 'fieldset--with-prefix',
  },
  withSuffix: {
    composes: 'fieldset--with-suffix',
  },
  prefixField: {
    composes: 'fieldset__field-prefix',
  },
  suffixField: {
    composes: 'fieldset__field-suffix',
  },
  wrapper: {
    composes: 'fieldset__field-wrapper',
  },
  field: {
    composes: 'field',
  },
  fieldMedium: {
    composes: 'field--medium',
  },
  fieldFocus: {
    composes: 'field--focus',
  },
  icon: {
    composes: 'fieldset__svg-icon',
  },
  label: {
    composes: 'field__label',
  },
  input: {
    composes: 'field__input',
  },
  placeholder: {
    composes: 'field__placeholder',
  },
  success: {
    composes: 'field-state--success',
  },
  close: {
    composes: 'field-state--close',
  },
  error: {
    composes: 'field__error',
  },
});

export default useStyles;
